import {
  UPDATE_VEHICLE_STATUS,
  UPDATE_VEHICLE_STATUS_SUCCESS,
  UPDATE_VEHICLE_STATUS_ERROR,
  UPDATE_VEHICLE_STATUS_EMPTY,
} from './../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdateVehicleStatus = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_VEHICLE_STATUS:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_VEHICLE_STATUS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UPDATE_VEHICLE_STATUS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case UPDATE_VEHICLE_STATUS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateVehicleStatus;
